import * as React from 'react';
import * as moment from 'moment';
import { ICalendarReduxState } from "../classes/index";
import { connect, Dispatch } from "react-redux";
import { waitForImage, imageHasLoaded } from "../redux/actions/index";

interface ImageExternalProps {
    srcUrl: string;
    date: moment.Moment;
}

interface StateToProps {
    shouldLoadImage: boolean;
    imageIsLoaded: boolean;
}

interface DispatchToProps {
    waitForImage: (monthString: string, id: string) => any;
    imageHasLoaded: (monthString: string, id: string) => any;
}

type ImageProps = ImageExternalProps & StateToProps & DispatchToProps;

class Image extends React.Component<ImageProps, null> {
    componentWillMount() {
        if (this.props.srcUrl) {
            this.props.waitForImage(this.props.date.format("MMMM-YYYY"), `${this.props.date.format("HH-MM")}${this.props.srcUrl}`);
        }
    }

    shouldComponentUpdate(nextProps: ImageProps) {
        if (this.props.imageIsLoaded) {
            return false;
        }

        return true;
    }

    private onImageLoad(evt: React.SyntheticEvent<HTMLImageElement>) {
        this.props.imageHasLoaded(this.props.date.format("MMMM-YYYY"), `${this.props.date.format("HH-MM")}${this.props.srcUrl}`);
    }

    render() {
        return <img onLoad={this.onImageLoad.bind(this)} src={(this.props.shouldLoadImage || this.props.imageIsLoaded) ? this.props.srcUrl : ""} className={`event-image ${(this.props.imageIsLoaded ? "loaded" : "")}`} />
    }
}

function mapStateToProps(state: ICalendarReduxState, externalProps: ImageExternalProps) {
    let imageIsLoaded = false;

    const monthImageHasLoaded = externalProps.date.format("MMMM-YYYY") in state.lazyLoaderModel.imageHasLoaded;

    if (monthImageHasLoaded && `${externalProps.date.format("HH-MM")}${externalProps.srcUrl}` in state.lazyLoaderModel.imageHasLoaded[externalProps.date.format("MMMM-YYYY")]) {
        imageIsLoaded = state.lazyLoaderModel.imageHasLoaded[externalProps.date.format("MMMM-YYYY")][`${externalProps.date.format("HH-MM")}${externalProps.srcUrl}`];
    }

    return {
        shouldLoadImage: state.lazyLoaderModel.imagesToLoad[externalProps.date.format("MMMM-YYYY")],
        imageIsLoaded: imageIsLoaded
    }
}

function mapDispatchToProps(dispatch: Dispatch<ICalendarReduxState>): DispatchToProps {
    return {
        waitForImage: (monthString: string, id: string) => dispatch(waitForImage(monthString, id)),
        imageHasLoaded: (monthString: string, id: string) => dispatch(imageHasLoaded(monthString, id))
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(Image);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/components/image.tsx